import type { IconProps } from './types';

export const LevelUp = (props: IconProps) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path
      d="M4.04087 24.5379V18.7686M4.04087 7.23017V1.46094M1.15625 4.34555H6.92548M1.15625 21.6532H6.92548M13.8486 2.61478L11.8476 7.81732C11.5222 8.66335 11.3595 9.08637 11.1065 9.44219C10.8822 9.75755 10.6067 10.0331 10.2913 10.2573C9.93553 10.5103 9.51251 10.673 8.66647 10.9984L3.46394 12.9994L8.66648 15.0004C9.51251 15.3258 9.93553 15.4885 10.2913 15.7415C10.6067 15.9657 10.8822 16.2412 11.1065 16.5566C11.3595 16.9124 11.5222 17.3354 11.8476 18.1815L13.8486 23.384L15.8495 18.1815C16.1749 17.3354 16.3376 16.9124 16.5906 16.5566C16.8149 16.2412 17.0904 15.9657 17.4058 15.7415C17.7616 15.4885 18.1846 15.3258 19.0306 15.0004L24.2332 12.9994L19.0306 10.9984C18.1846 10.673 17.7616 10.5103 17.4058 10.2573C17.0904 10.0331 16.8149 9.75755 16.5906 9.44219C16.3376 9.08637 16.1749 8.66335 15.8495 7.81732L13.8486 2.61478Z"
      stroke="currentColor"
      strokeWidth="2.30769"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
